import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { TabCentroCustoComponent } from '../components/tab-centro-custo/tab-centro-custo.component';
import { TabColaboradoresComponent } from '../components/tab-colaboradores/tab-colaboradores.component';
import { TabDadosEmpresaComponent } from '../components/tab-dados-empresa/tab-dados-empresa.component';
import { TabFiliaisComponent } from '../components/tab-filiais/tab-filiais.component';
import { TabMedicosComponent } from '../components/tab-medicos/tab-medicos.component';
import { TabUsuariosAdminComponent } from '../components/tab-usuarios-admin/tab-usuarios-admin.component';
import { SharedModule } from './../../../shared/shared.module';
import { EditCompanyRoutingModule } from './edit-company.-routing.module';
import { EditCompanyComponent } from './edit-company.component';
import { TabAtendentesComponent } from '../components/tab-atendentes/tab-atendentes.component';
import { TabAddReasonComponent } from '../components/tab-add-reason/tab-add-reason.component';

@NgModule({
  imports: [CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule, SharedModule, EditCompanyRoutingModule, MatIconModule, MatMenuModule],
  declarations: [
    EditCompanyComponent,
    TabCentroCustoComponent,
    TabColaboradoresComponent,
    TabDadosEmpresaComponent,
    TabFiliaisComponent,
    TabMedicosComponent,
    TabUsuariosAdminComponent,
    TabAtendentesComponent,
    TabAddReasonComponent
  ]
})
export class EditCompanyModule { }
